import { Component, html, LitElement, property } from '@rxdi/lit-html';
import { Router } from '@rxdi/router';

/**
 * @customElement router-link2
 */
@Component({
  selector: 'router-link2',
  template(this: RouterLinkComponent) {
    return html` <slot @click=${() => this.path && this.router.go(this.path)}></slot> `;
  },
})
export class RouterLinkComponent extends LitElement {
  @Router() router: Router;
  @property({ type: String }) path: string;
}
